import React, { useState } from 'react';
import { Box, Container, CssBaseline, Typography, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from 'react-phone-input-2';
// @ts-ignore: imported for side effects, no type declarations for CSS module
import 'react-phone-input-2/lib/material.css';
import { toast } from '../../common/SnackBar/snackBar';
import ForgetPasswordPageStyles from '../../../styles/PublicPage/resetPassword';
import { sendOtp } from '../../../api/AuthAPI';
import { PATH_NAME } from '../../../configs/pathName';
import { typo } from '../../../assets/fonts/font';
import colorConfigs from '../../../configs/colorConfigs';

const ForgetPasswordPage: React.FC = () => {
    const navigate = useNavigate();
    const [phone, setPhone] = useState("");

    const handleSendOtp = async () => {
        const fullMobile = `+${phone.match(/\d+/)?.[0]}`;
    
        if (fullMobile) {
            try {
                const response = await sendOtp(fullMobile);
                if (response.success) {
                    toast.success("OTP sent successfully!");
                    navigate(PATH_NAME.RESET_PASSWORD_VERIFY, { state: { phone: fullMobile } });
                } else {
                    toast.error(response.error_message);
                }
            } catch (error: any) {
                toast.error(error.message);
            }
        } else {
            toast.error("Please enter a valid phone number.");
        }
    };
    
    return (
        <>
            <Box sx={ForgetPasswordPageStyles.container}>
                <Container maxWidth="xs" sx={ForgetPasswordPageStyles.contentContainer}>
                    <CssBaseline />
                    <Typography variant="h5" component="h1" gutterBottom align="left" sx={{...typo.sectionHeadline,...ForgetPasswordPageStyles.headerText}}>
                        Reset Your Password
                    </Typography>
                    <Typography variant="body1" gutterBottom align="left" sx={{...typo.bodyContent, ...ForgetPasswordPageStyles.descriptionText}}>
                        Enter your phone number to receive an OTP for resetting your password.
                    </Typography>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <Box sx={{...typo.bodyContent, ...ForgetPasswordPageStyles.phoneInputContainer}}>
                            <PhoneInput
                                country={'sg'}
                                value={phone}
                                onChange={setPhone}
                                inputProps={{
                                    name: 'phone',
                                    required: true,
                                    autoFocus: true,
                                }}
                                containerStyle={{
                                    width: "100%",
                                    border: "1px solid",
                                    borderRadius: "4px",
                                    borderColor:colorConfigs.primary,
                                    ...typo.bodyContent,
                                  }}
                                  inputStyle={{
                                    width: "100%",
                                    border: "none",
                                    outline: "none",
                                    boxShadow: "none",
                                    ...typo.bodyContent,
                                  }}                            
                                  />
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{...typo.bodyContent, ...ForgetPasswordPageStyles.sendOtpButton}}
                                onClick={handleSendOtp}
                            >
                                Send OTP
                            </Button>
                            <Typography variant="body2" align="center" sx={{...typo.bodyContent}}>
                                Remembered your password?{' '}
                                <Link to={PATH_NAME.LOGIN} style={{...typo.bodyContent, ...ForgetPasswordPageStyles.loginLink}}>
                                    Log in
                                </Link>
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </>
    );
};

export default ForgetPasswordPage;